import React, { useState, createContext, useContext } from 'react';
import config from './config';

export const StoreContext = createContext();

export const Store = (props) => {
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [remove, setRemove] = useState(null);
  const [cancel, setCancel] = useState(null);
  const [user, setUser] = useState(null);
  const [lang, setLang] = useState(config.default_lang);
  const [actionMsg, setActionMsg] = useState('');
  

  return (
    <StoreContext.Provider
      value={{
        successMsg,
        setSuccessMsg,
        errorMsg,
        setErrorMsg,
        remove,
        setRemove,
        cancel,
        setCancel,
        user,
        setUser,
        lang,
        setLang,
        actionMsg,
        setActionMsg
      }}>
      {props.children}
    </StoreContext.Provider>
  );
};

const useStore = () => useContext(StoreContext);

export default useStore;
